"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collection = void 0;
const node_1 = require("./node");
const types_1 = require("../types");
class Collection extends node_1.Node {
    constructor(collectionProto) {
        super(collectionProto, null);
        this.name = collectionProto.name;
        this.description = collectionProto.description;
        this.code = collectionProto.code;
        this.creator = collectionProto.creator;
        this.owner = collectionProto.owner;
        this.banner = collectionProto.banner ? new types_1.FileVersion(collectionProto.banner) : undefined;
        this.thumbnail = collectionProto.thumbnail ? new types_1.FileVersion(collectionProto.thumbnail) : undefined;
        this.udl = new types_1.UDL(collectionProto.udl);
        this.ucm = collectionProto.ucm;
        this.items = collectionProto.items;
        this.type = collectionProto.type;
        this.uri = this.getUri();
    }
    getUri() {
        var _a;
        return (_a = this.data) === null || _a === void 0 ? void 0 : _a[1];
    }
}
exports.Collection = Collection;
